import { ChangeEvent, FC, KeyboardEventHandler } from "react"
import { ChangeType, RefType } from "../../../api/EventTypes"
import { useAppSelector } from "../../../app/hooks"

import Tooltip from "../tooltip"
import Label from "./Label"
export interface IInput {
  name: string
  label?: string
  error?: string
  value: string | number
  type?: string
  inputIdentifier: string
  isOptional?: boolean
  isOptionalShort?: boolean
  labelOnBorder?: boolean
  checked?: boolean
  placeholder?: string
  readonly?: boolean
  hasChanges?: boolean
  maxLength?: number
  uppercase?: boolean
  onChange: (e: ChangeType) => void
  onBlur?: (e: ChangeType) => void
  onInput?: (e: ChangeEvent<HTMLInputElement>) => void
  onKeyUp?: KeyboardEventHandler<HTMLInputElement>
  onKeyPress?: KeyboardEventHandler<HTMLInputElement>
  className?: string
  absoluteOptional?: boolean
  autoFocus?: boolean
  inputRef?: RefType
  hideErrorMsg?: boolean
  showTooltip?: boolean
  disabled?: boolean
}

const Input: FC<IInput> = (props: IInput) => {
  const { useLocalTime } =
    useAppSelector(
      (state) => state["selectionReducer"].airportSeasonsSelector
    ) || {}
  const invalidFields = props.showTooltip ? " input-invalid" : ""
  const invalidFieldsContainer = props.showTooltip
    ? "input-container-invalid"
    : ""

  return (
    <div
      className={
        " ocs-field-container " +
        invalidFieldsContainer +
        (props.labelOnBorder ? "label-on-border" : "")
      }
    >
      <div className="d-flex">
        {props.label && (
          <Label
            htmlFor={props.inputIdentifier}
            optional={props.isOptional}
            label={props.label}
          />
        )}
        {props?.showTooltip ? <Tooltip>{props.error}</Tooltip> : null}
      </div>
      {props.readonly ? (
        <p
          className={
            "ocs-field-readonly" +
            (props.hasChanges
              ? useLocalTime
                ? " has-changes local-time"
                : " has-changes"
              : "") +
            (props.uppercase ? " input-uppercase" : "")
          }
        >
          {props.value}
        </p>
      ) : (
        <input
          type={!props.type ? "text" : props.type}
          name={props.name}
          value={props.value ?? ""}
          id={props.inputIdentifier}
          placeholder={props.placeholder}
          onChange={props.onChange}
          className={
            "ocs-field" +
            invalidFields +
            (props.uppercase ? " input-uppercase" : "") +
            (props.hasChanges
              ? useLocalTime
                ? " has-changes local-time"
                : " has-changes"
              : "")
          }
          onBlur={props.onBlur}
          onInput={props.onInput}
          maxLength={props.maxLength}
          autoFocus={props?.autoFocus}
          ref={props?.inputRef}
          onKeyUp={props.onKeyUp}
          onKeyPress={props.onKeyPress}
        />
      )}
      {props.error && !props.hideErrorMsg && (
        <span className="invalid">{props.error}</span>
      )}
    </div>
  )
}

export default Input
